import { getGraphqlUri, LOCAL_BACKEND_GRAPHQL_PATH } from "@/lib/backendSource";

/** OAuth scopes for Cursor MCP — matches pgatech plugin MCP overlay. */
export const MCP_OAUTH_SCOPES = ["openid", "profile", "offline_access"] as const;

/** Member 360 Okta app client IDs — same apps as staff login. */
export const MCP_OKTA_CLIENT_IDS = {
  dev: "0oa1odkwvmbwQjLrc358",
  prod: "0oa1opc4ll92ESe4y358"
} as const;

export const MCP_ENDPOINTS = {
  dev: "https://coach-tools.dev.pga.com/backoffice/mcp",
  prod: "https://coach-tools.pga.com/backoffice/mcp"
} as const;

/** Match the Backoffice GraphQL host the staff app is using. */
export function getRecommendedMcpEndpoint(graphqlUri: string = getGraphqlUri()): string {
  if (graphqlUri === LOCAL_BACKEND_GRAPHQL_PATH) {
    return "/local-backoffice/mcp";
  }

  if (/coach-tools\.pga\.com/.test(graphqlUri) && !/coach-tools\.dev\.pga\.com/.test(graphqlUri)) {
    return MCP_ENDPOINTS.prod;
  }

  return MCP_ENDPOINTS.dev;
}

/** Staff MCP playground BFF — same host as Backoffice GraphQL. */
function getAgentBaseUrl(graphqlUri: string = getGraphqlUri()): string {
  if (graphqlUri === LOCAL_BACKEND_GRAPHQL_PATH) {
    return "/local-backoffice";
  }

  if (graphqlUri.startsWith("/")) {
    return "";
  }

  return graphqlUri.replace(/\/graphql\/?$/, "");
}

export function getAgentChatUrl(graphqlUri: string = getGraphqlUri()): string {
  const base = getAgentBaseUrl(graphqlUri);
  if (base === "/local-backoffice") {
    return "/local-backoffice/agent/chat";
  }

  return base ? `${base}/agent/chat` : "/backoffice/agent/chat";
}

export function getAgentStatusUrl(graphqlUri: string = getGraphqlUri()): string {
  const base = getAgentBaseUrl(graphqlUri);
  if (base === "/local-backoffice") {
    return "/local-backoffice/agent/status";
  }

  return base ? `${base}/agent/status` : "/backoffice/agent/status";
}

export function getAgentExecuteWriteUrl(graphqlUri: string = getGraphqlUri()): string {
  const base = getAgentBaseUrl(graphqlUri);
  if (base === "/local-backoffice") {
    return "/local-backoffice/agent/execute_write";
  }

  return base ? `${base}/agent/execute_write` : "/backoffice/agent/execute_write";
}

export const MCP_PLAYGROUND_SUGGESTIONS = [
  "Who are the active members in Southern Ohio?",
  "Compare members, associates, and students in Michigan",
  "Who is on the Southern Ohio section board?",
  "What committees does Carolinas have?",
  "How many active members are in Carolinas?",
  "Search for people named Smith",
  "List facilities in Georgia",
  "Show open job posts in Carolinas"
] as const;
